import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { ALLOWED_ORGS_QA_STAGING } from '@/constants/common';

import { selectedOrganizationAtom } from '../Organizations';
import { envAtom, showAlertAtom } from './Administration.store';
import type { EnvModel } from './Administration.types';

const useFetchEnvironment = () => {
  const [, setEnv] = useAtom(envAtom);
  const envQuery = useQuery<EnvModel>({
    queryKey: [`environments/environment`],
    staleTime: Infinity,
    enabled: true
  });

  useEffect(() => {
    setEnv(envQuery?.data?.env || '');
  }, [envQuery.data]);
  return envQuery;
};

export const useCrudGuard = (action: (...args: unknown[]) => void) => {
  const [environment] = useAtom(envAtom);
  const [selectedOrgData] = useAtom(selectedOrganizationAtom);
  const [, setShowAlert] = useAtom(showAlertAtom);

  return (...args: unknown[]) => {
    if (
      (environment === 'qa' || environment === 'staging') &&
      !ALLOWED_ORGS_QA_STAGING.has(selectedOrgData?.label ?? '')
    ) {
      // CRUD operations are allowed only for specific organizations in QA and Staging.
      setShowAlert(true);
      return;
    }
    action(...args);
  };
};

export default useFetchEnvironment;
